export default {
  results: [],
  columns: [],
  headerColumns: [],
  parameters: ''
};
